(function () {
  /* ---- 0. Load marked.js ---------------------------------- */
  const mdScript = document.createElement("script");
  mdScript.src = "https://cdn.jsdelivr.net/npm/marked/marked.min.js";
  document.head.appendChild(mdScript);

  /* ---- 1. Config ----------------------------------------- */
  const CFG = {
    apiKey:    "68db91fa-6379-4064-bfc1-f9b07add8dec",
    endpoint:  "https://cloud-simbas.onrender.com/api/conversations/send-conversation-agent",
    position:  "bottom-right",
    bubbleText:"Need help? Chat now",
    title:     "Miss Gummly",
    orgId:     "fdbb22f3-f48d-4491-9f6e-232fe814885a",
    agentId:   "52463adb-a5d4-4691-9699-c31957837e91",
  };

  /* ---- 2. Utils ------------------------------------------ */
  const uuid = () =>
    crypto.randomUUID
      ? crypto.randomUUID()
      : ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
          (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c/4)))).toString(16)
        );
  const isoNow = () => new Date().toISOString();

  /* ---- 3. Persistence Setup ------------------------------- */
  const storageKey = `cs-chat-${CFG.orgId}-${CFG.agentId}`;
  let conversationId;
  let messages = [];

  const saveState = () =>
    localStorage.setItem(storageKey, JSON.stringify({ conversationId, messages }));

  /* ---- 4. CSS Injection ----------------------------------- */
  const css = `
    .cs-chat-bubble{all:unset;position:fixed;${CFG.position.startsWith("bottom")?"bottom":"top"}:24px;${CFG.position.endsWith("right")?"right":"left"}:24px;background:#39b1d4;color:#ffffff;border-radius:9999px;padding:12px 16px;font:600 14px/1.2 system-ui,sans-serif;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.15);z-index:9998;}
    .cs-chat-window{position:fixed;${CFG.position.startsWith("bottom")?"bottom":"top"}:80px;${CFG.position.endsWith("right")?"right":"left"}:24px;width:320px;height:480px;background:#ffffff;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.2);display:flex;flex-direction:column;overflow:hidden;z-index:9999;font:14px/1.5 system-ui,sans-serif;color:#000000;}
    .cs-chat-header{background:#39b1d4;color:#ffffff;padding:12px 16px;font-weight:600;}
    .cs-chat-messages{flex:1;padding:12px 16px;overflow-y:auto;}
    .cs-chat-input{display:flex;border-top:1px solid #e2e8f0;}
    .cs-chat-input input{flex:1;border:none;padding:12px 16px;font:inherit;background:#ffffff;color:#000000;}
    .cs-chat-input input:focus, .cs-chat-input input:focus-visible{outline:none!important;box-shadow:none!important;}
    .cs-chat-input button{all:unset;background:#39b1d4;color:#ffffff;padding:0 16px;cursor:pointer;}
    .cs-chat-bubble:focus-visible, .cs-chat-input button:focus-visible{outline:3px solid #39b1d4;outline-offset:2px;}
    .cs-bot{display:inline-block;padding:8px 12px;border-radius:12px;max-width:85%;background:#e5e7eb;color:#000000;}
    .cs-user{display:inline-block;padding:8px 12px;border-radius:12px;max-width:85%;background:#39b1d4;color:#ffffff;}
  `;
  const style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  /* ---- 5. Build and Append DOM ---------------------------- */
  const bubble = document.createElement("button");
  bubble.className = "cs-chat-bubble";
  bubble.innerText = CFG.bubbleText;

  const win = document.createElement("div");
  win.className = "cs-chat-window";
  win.style.display = "none";
  win.innerHTML = `
    <div class="cs-chat-header">${CFG.title}</div>
    <div class="cs-chat-messages" id="csChatMsgs"></div>
    <form class="cs-chat-input">
      <input type="text" placeholder="Type a message…" autocomplete="off" />
      <button type="submit">➤</button>
    </form>
  `;

  document.body.appendChild(bubble);
  document.body.appendChild(win);

  /* ---- 6. Message Renderer ------------------------------- */
  const addMsg = (text, from) => {
    const wrap = document.createElement("div");
    wrap.style.margin = "8px 0";
    wrap.style.textAlign = from === "user" ? "right" : "left";
    const msgEl = document.createElement("div");
    msgEl.className = from === "user" ? "cs-user" : "cs-bot";
    if (window.marked) msgEl.innerHTML = marked.parse(text);
    else msgEl.textContent = text;
    wrap.appendChild(msgEl);
    document.getElementById("csChatMsgs").appendChild(wrap);
    wrap.scrollIntoView({ block: "end" });
  };

  /* ---- 7. Restore Saved Conversation ---------------------- */
  const saved = localStorage.getItem(storageKey);
  if (saved) {
    try {
      const obj = JSON.parse(saved);
      conversationId = obj.conversationId;
      messages = obj.messages;
      messages.forEach(m => addMsg(m.Content, m.Sender));
    } catch {
      conversationId = uuid();
      messages = [];
    }
  } else {
    conversationId = uuid();
    messages = [];
  }

  /* ---- 8. Loading Indicator Helpers ----------------------- */
  const showLoading = () => {
    if (document.getElementById("csLoading")) return;
    const wrap = document.createElement("div");
    wrap.id = "csLoading";
    wrap.style.margin = "8px 0";
    wrap.style.textAlign = "left";
    const span = document.createElement("span");
    span.className = "cs-bot";
    span.textContent = "…typing";
    wrap.appendChild(span);
    document.getElementById("csChatMsgs").appendChild(wrap);
    wrap.scrollIntoView({ block: "end" });
  };
  const removeLoading = () => {
    const el = document.getElementById("csLoading");
    if (el) el.remove();
  };

  /* ---- 9. Networking -------------------------------------- */
  const sendToServer = async () => {
    showLoading();
    const payload = {
      ConversationId: conversationId,
      OrgId:           CFG.orgId,
      AgentId:         CFG.agentId,
      CreatedAt:       messages[0]?.CreatedAt || isoNow(),
      UpdatedAt:       isoNow(),
      Messages:        messages,
    };
    try {
      const res = await fetch(CFG.endpoint, {
        method: "POST",
        headers: {
          "Content-Type":       "application/json",
          "Authorization":      `ApiKey ${CFG.apiKey}`,
          "cloudsafaris-version":"v1",
        },
        body: JSON.stringify(payload),
      }).then(r => r.json());

      removeLoading();

      // only append brand-new system messages
      const seen = new Set(messages.map(m => m.MessageId));
      (res.Messages || [])
        .filter(m => m.Sender === "system" && !seen.has(m.MessageId))
        .forEach(m => {
          messages.push(m);
          addMsg(m.Content, "bot");
        });

      saveState();

      if (res.ConversationId && !conversationId) {
        conversationId = res.ConversationId;
        messages.forEach(m => m.ConversationId = conversationId);
        saveState();
      }
    } catch (e) {
      console.error(e);
      addMsg("Something went wrong. Please try again later.", "bot");
      removeLoading();
      saveState();
    }
  };

  /* ---- 10. Event Handlers --------------------------------- */
  bubble.addEventListener("click", () => {
    win.style.display = win.style.display === "none" ? "flex" : "none";
  });
  win.querySelector("form").addEventListener("submit", async e => {
    e.preventDefault();
    const input = win.querySelector("input");
    const text  = input.value.trim();
    if (!text) return;

    addMsg(text, "user");
    messages.push({
      MessageId:       uuid(),
      ConversationId:  conversationId,
      Sender:          "user",
      Content:         text,
      CreatedAt:       isoNow(),
      UpdatedAt:       isoNow(),
    });
    saveState();

    input.value = "";
    await sendToServer();
  });
})();
